// import React, { useState, useEffect, useContext } from 'react';
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Popover from '@material-ui/core/Popover';
import SimpleBar from 'simplebar-react';

// import { LayoutContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../common/definitionHelper';
import { getUniqueKey } from '../../common/arrayHelper';
// import {  } from '../../common/constants';

import AfitdTypography from '../../common/elemental/AfitdTypography';

import InterviewBlock from './InterviewBlock';

// import cx from 'clsx';
import _get from 'lodash/get';
// import _set from 'lodash/set';
import _map from 'lodash/map';
import _filter from 'lodash/filter';

const styles = theme => ({
    root: {
        backgroundColor: '#FFFFFF',
    },
    popoverPaper: {
        overflow: 'hidden',
    },
    header: {
        padding: '10px 2px 10px 2px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
    closeButtonContainer: {
        position: 'absolute',
        right: 0,
        top: 0,
    },
    body: {
        padding: '2px',
        width: '200px',
        maxHeight: '300px',
        overflow: 'auto',
        display: 'flex',
        flexDirection: 'column',
        '&::-webkit-scrollbar-track': {
            borderRadius: '10px',
            background: 'none',
        },
        '&::-webkit-scrollbar': {
            width: '8px',
            backgroundColor: '#F5F5F5',
        },
        '&::-webkit-scrollbar-thumb': {
            borderRadius: '10px',
            backgroundColor: 'rgba(0,0,0,0.2)',
        },
    },
});

const getDefns = params => {
    const { props, setInterviewListPopoverOpen } = params;
    const { open, onClose, anchorEl, dayOfWeek, dayOfMonth, classes } = props;
    const { popoverPaper: popoverPaperCls } = classes;

    const defns = {
        interviewListPopover: {
            open,
            onClose,
            anchorEl,
            anchorOrigin: {
                vertical: 'top',
                horizontal: 'right',
            },
            transformOrigin: {
                vertical: 'top',
                horizontal: 'left',
            },
            classes: { paper: popoverPaperCls },
        },
        dayOfWeekText: {
            variant: 'caption',
            value: dayOfWeek,
        },
        dayOfMonthText: {
            variant: 'h5',
            value: dayOfMonth,
        },
        closeButtonContainer: {
            onClick: handleClickCloseIconButton.bind(null, setInterviewListPopoverOpen),
        },
    };

    setClassNameInDefns(defns, classes);

    return defns;
};

const handleClickCloseIconButton = setInterviewListPopoverOpen => {
    setInterviewListPopoverOpen(false);
};

const InterviewListPopover = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    // const context = useContext(LayoutContext);
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Local states
    // const [yyyyyyyyy, setYyyyyyyyy] = useState();
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // From props
    const { interviewList = [], dayId, dt, setInterviewListPopoverOpen } = props;
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Derived
    const dayInterviewList = _filter(interviewList, item => _get(item, 'dayId') === dayId);
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Side effects
    // useEffect(() => {
    //     const newDefns = getDefns(props, { });
    //     setDefns(newDefns);
    // }, [props]);
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Defns
    const defns = getDefns({ props, setInterviewListPopoverOpen });
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Render
    return (
        <Popover {...defns.interviewListPopover}>
            <div {...defns.header}>
                <div {...defns.dayOfWeekContainer}>
                    <AfitdTypography {...defns.dayOfWeekText} />
                    <div {...defns.closeButtonContainer}>
                        <IconButton {...defns.closeIconButton}>
                            <CloseIcon />
                        </IconButton>
                    </div>
                </div>
                <div {...defns.dayOfMonthContainer}>
                    <AfitdTypography {...defns.dayOfMonthText} />
                </div>
            </div>
            <div {...defns.body}>
                <SimpleBar style={{ width: '100%', flex: 1 }}>
                    {_map(dayInterviewList, (interview, idx) => {
                        const defn = {
                            interviewData: interview,
                            dt,
                        };
                        return <InterviewBlock key={`interviewBlock-${getUniqueKey()}`} isPopover={true} {...defn} />;
                    })}
                </SimpleBar>
            </div>
        </Popover>
    );
    //---------------------------------------------------------------------
};

export default withStyles(styles)(InterviewListPopover);
